// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"400aee93","878":"64d8bc00"}[chunkId] + ".chunk.js";
};